import { GridRowProps, GridCustomRowProps } from '@progress/kendo-react-grid';
import { forEach } from 'lodash';

export const TotalRow = (props: GridCustomRowProps) => {
  let totalRow =  (
    <tr {...props.trProps}>
        {props.children}
    </tr>
  );

  if (props.dataItem) {
    forEach(props.dataItem, (value, key) => {
      if (typeof value === 'string' && value.includes('Total')) {
        totalRow = (
          <tr {...props.trProps} className='grid-total-row'>
              {props.children}
          </tr>
        );
      }
    });
  }
  return (totalRow);
};